import { formatCount } from '@wit-support/ui';
/**
 * Тексты тревог запуска и пачки (стенд v5, N1/N2). Правило: до фактического
 * старта (время старта запуска, показывается по Лос-Анджелесу) никогда не
 * писать «тратит бюджет» / «кампании работают» — показов ещё нет; что на паузе
 * — называть паузой.
 */
/** Старт прошёл? null — время старта неизвестно. */
export function startPassed(startIso, now) {
    if (startIso == null)
        return null;
    const t = Date.parse(startIso);
    return Number.isNaN(t) ? null : t <= now;
}
export function pausedOnDriftTextRu(c) {
    const head = 'Meta изменила настройки до старта — запуск на паузе, показов не было. Проверьте сверку ниже.';
    const has = (a) => c.actions.includes(a);
    const server = c.serverActions ?? c.actions;
    if (has('activate'))
        return `${head} Если расхождения допустимы — «Включить».`;
    if (has('force')) {
        return `${head} Включить вопреки расхождениям можно кнопкой «Включить всё равно».`;
    }
    if (server.includes('force_activate') || server.includes('force')) {
        return `${head} Включить вопреки расхождениям («Включить всё равно») может только владелец.`;
    }
    const check = has('reverify') ? ' «Перепроверить» покажет, что в Meta сейчас.' : '';
    const owner = c.canForceActivate
        ? ' «Включить всё равно» для подмены до старта не предусмотрено.'
        : '';
    const rollback = has('rollback')
        ? 'откатите его («Откатить») и создайте запуск заново'
        : 'его нужно откатить и создать заново — откатить могут супервайзер и владелец';
    return `${head} Включить этот запуск из конструктора нельзя — даже после перепроверки.${owner}${check} Чтобы запустить рекламу, ${rollback}.`;
}
/**
 * «Требует внимания» на карточке запуска. Автопаузы нет, кампания включена;
 * тратит ли она бюджет — по фактическому старту: до него показов и трат нет.
 */
export function needsAttentionTextRu(c) {
    const passed = startPassed(c.startIso, c.now);
    const when = c.startLabel != null ? ` ${c.startLabel}` : ' со времени старта';
    // кампания включена: что это значит для денег — по старту
    const money = passed === true
        ? 'кампания тратит бюджет'
        : passed === false
            ? `старт ещё не наступил — показов и трат пока нет, показы начнутся${when}`
            : 'кампания включена и со старта тратит бюджет';
    const pauseHint = passed === false
        ? 'при необходимости поставьте на паузу до старта'
        : 'при необходимости поставьте на паузу';
    if (c.reason === 'verify-unavailable') {
        return `Сверку с Meta после включения не удалось провести несколько раз подряд. Автопаузы нет — ${money}. Проверьте кампанию в Ads Manager и ${pauseHint}.`;
    }
    if (c.reason === 'pause-failed') {
        const tries = c.pauseAttempts != null && c.pauseAttempts > 0 ? ` (попыток: ${c.pauseAttempts})` : '';
        return `Meta подменила настройки, а поставить кампанию на паузу так и не удалось${tries} — сервер рекламы больше не пытается. Сейчас ${money}: остановите её вручную («Пауза» или в Ads Manager)${passed === false ? ' до старта' : ''}.`;
    }
    const head = passed === false
        ? 'Перепроверка нашла подмену: Meta изменила настройки кампании до старта.'
        : passed === true
            ? 'После старта Meta изменила настройки кампании.'
            : 'Перепроверка нашла подмену: Meta изменила настройки кампании.';
    return `${head} Автопаузы нет — ${money}: проверьте сверку ниже и ${pauseHint}.`;
}
/** `pause_failed` на карточке: подмена требовала паузы, PAUSED не прошёл (сервер повторяет). */
export function pauseFailedTextRu(c) {
    const passed = startPassed(c.startIso, c.now);
    const tail = passed === false
        ? 'До старта показов и трат нет; если пауза не пройдёт — остановите кампанию вручную до старта («Пауза» или в Ads Manager).'
        : 'Кампания включена; если не выйдет — остановите её вручную («Пауза» или в Ads Manager).';
    return `Meta подменила настройки, но поставить кампанию на паузу не удалось — сервер рекламы повторяет попытку. ${tail}`;
}
/**
 * Решение «создавать включённым» откатили на ходу (`createDecision.downgraded`):
 * у каждой причины своё пояснение; «показов не было» — только когда пауза
 * прошла раньше старта.
 */
export function createDowngradeTextRu(c) {
    const paused = c.pausedAt != null && c.pausedAt !== '';
    const pausedT = paused ? Date.parse(c.pausedAt) : NaN;
    const startT = c.startIso != null ? Date.parse(c.startIso) : NaN;
    const beforeStart = !Number.isNaN(pausedT) && !Number.isNaN(startT) && pausedT < startT;
    const pausedPart = paused
        ? `созданное поставлено на паузу${beforeStart ? ', показов не было' : ''}`
        : 'созданное ставится на паузу';
    switch (c.reason) {
        case 'create-interrupted':
            return `Meta отклонила часть объектов при создании — ${pausedPart}.`;
        case 'prestart-guard':
            return `Создание начиналось включённым, но не закончилось к проверке перед стартом — остаток создаётся на паузе, ${pausedPart}.`;
        case 'start-too-close':
            return `Создание начиналось включённым, но до старта оставалось слишком мало времени — остаток создан на паузе, ${pausedPart}.`;
        default:
            return `Создание начиналось включённым, но решение пересмотрели (${c.reason}) — остаток создан на паузе, ${pausedPart}.`;
    }
}
/**
 * Запуск упал после отката «создавать включённым», и пауза созданного прошла,
 * а включать с тех пор не пробовали: всё на паузе — «Пауза» не нужна (зеркало
 * `isTakenBackPaused` auto-ads, на случай старого сервера).
 */
export function isTakenBackPaused(l) {
    return (l.displayStatus === 'failed' &&
        !!l.createDecision?.downgraded?.pausedAt &&
        !(l.steps ?? []).some((s) => s.kind.startsWith('activate.') && s.status !== 'pending' && s.status !== 'skipped'));
}
const ATTENTION = new Set(['needs_attention', 'pause_failed']);
/**
 * Плашка пачки «N запусков требуют внимания». `total` — из счётчиков пачки
 * (список запусков может не прийти). Что тратит — по фактическому старту
 * каждого запуска.
 */
export function batchAttentionTextRu(launches, total, now) {
    const head = `${formatCount(total, ['запуск требует', 'запуска требуют', 'запусков требуют'])} внимания: Meta изменила настройки или поставить кампанию на паузу не удалось — автопаузы нет.`;
    const listed = launches.filter((l) => ATTENTION.has(l.displayStatus));
    let started = 0;
    let ahead = 0;
    for (const l of listed) {
        const p = startPassed(l.startTime, now);
        if (p === true)
            started += 1;
        else if (p === false)
            ahead += 1;
    }
    const unknown = total - started - ahead;
    const open = 'Откройте запуск, проверьте сверку и при необходимости поставьте на паузу';
    if (ahead > 0 && started === 0 && unknown <= 0) {
        return `${head} Старт ещё не наступил — показов и трат пока нет. ${open} до старта.`;
    }
    if (started > 0 && ahead === 0 && unknown <= 0) {
        return `${head} Старт уже прошёл — кампании тратят бюджет. ${open}.`;
    }
    if (started > 0 || ahead > 0) {
        const parts = [];
        if (started > 0)
            parts.push(`уже стартовали и тратят бюджет — ${started}`);
        if (ahead > 0)
            parts.push(`ждут старта, трат пока нет — ${ahead}`);
        return `${head} Из них ${parts.join('; ')}. ${open}.`;
    }
    return `${head} Кампании включены и со старта тратят бюджет. ${open}.`;
}
//# sourceMappingURL=attention-texts.js.map